module.exports = __webpack_public_path__ + "static/media/bolso (18).cd764228.jpg";